// Paket Sipariş Ekranı (kasiyer ekranı) kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'sales.packageOrderScreen';

export const packageOrderScreenGuide = (t: TFunction): GuideContent => ({
  layout: 'card',
  title: t(`${G}.title`, 'Paket Sipariş Ekranı nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'Solda arayan müşteri, ortada siparişler, sağda işlem düğmeleri bulunur. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Üst çubuk'),
    strip: t(`${G}.regions.strip`, 'Kanal sekmeleri'),
    nav: t(`${G}.regions.nav`, 'Arayan / Müşteri'),
    content: t(`${G}.regions.content`, 'Sipariş listesi'),
    summary: t(`${G}.regions.summary`, 'İşlem düğmeleri'),
    footer: t(`${G}.regions.footer`, 'Günlük sayılar'),
  },
  navItems: [
    t(`${G}.nav.incomingCall`, 'Gelen Arama'),
    t(`${G}.nav.customer`, 'Müşteri'),
    t(`${G}.nav.addresses`, 'Adresler'),
    t(`${G}.nav.recentCalls`, 'Son Aramalar'),
  ],
  steps: [
    {
      region: 'nav',
      title: t(`${G}.s1.title`, '1. Arayan müşteriyi bulun'),
      text: t(`${G}.s1.text`, 'Telefon çalınca solda "Gelen Arama" kutusu açılır; "Cevapla"ya basın, müşteri ve adresleri gelir. Arayan kayıtlı değilse "Yeni Müşteri Kaydet" ile kaydedin.'),
      tips: [
        t(`${G}.s1.tip1`, 'Arama yoksa: "YENİ SİPARİŞ"e basın, "Müşteri Ara" penceresinde ad soyad (en az 2 harf) ya da telefon yazın.'),
        t(`${G}.s1.tip2`, '"Son Aramalar" listesinden de müşteri seçebilirsiniz; "Tümünü Gör" tüm aramaları açar.'),
        t(`${G}.s1.tip3`, 'Adresler listesinden teslimat adresini seçin; yoksa "Yeni Adres" ekleyin.'),
        t(`${G}.s1.tip4`, 'Kasiyer sistemi açıksa önce üstteki "Kasiyer Girişi" yapılmalıdır.'),
      ],
    },
    {
      region: 'summary',
      title: t(`${G}.s2.title`, '2. Sepeti hazırlayın ve onaylayın'),
      text: t(`${G}.s2.text`, 'Müşteri ve adres seçiliyken "YENİ SİPARİŞ" ürün ekranını açar. Ürünleri sepete ekleyip "SEPETİ ONAYLA"ya basın. Onaydan sonra mutfak fişi ve adisyon kendiliğinden yazdırılır.'),
      tips: [
        t(`${G}.s2.tip1`, '"İLAVE SİPARİŞ": kuryeye verilmemiş bir siparişe ürün ekler. Mutfağa yalnız eklenen ürünler "İLAVE SİPARİŞ" başlığıyla gider; adisyon yeniden basılmaz.'),
        t(`${G}.s2.tip2`, 'Düğmede "Aynı adreste aktif sipariş var" yazıyorsa bu yalnız bir hatırlatmadır; yine de sipariş açabilirsiniz.'),
      ],
    },
    {
      region: 'strip',
      title: t(`${G}.s3.title`, '3. Kanal sekmelerini kullanın'),
      text: t(`${G}.s3.text`, 'Tümü, Telefon, Y.Sepeti, Uber Eats, Migros, Kiosk, QR Menü ve E-Ticaret sekmeleri siparişleri kanala göre ayırır. Yalnız ekran ayarlarında açık olan kanallar görünür.'),
      tips: [
        t(`${G}.s3.tip1`, 'Kırmızı sekme: o platformdaki mağazanız kapalı. Turuncu sekme: mağazalardan biri kapalı (kısmen açık).'),
        t(`${G}.s3.tip2`, 'Takvim simgesi son 7 günden birini gösterir. Tarih filtresi açıkken yeni siparişler ekrana düşmez; "Filtreyi Temizle" ile bugüne dönün.'),
      ],
    },
    {
      region: 'content',
      title: t(`${G}.s4.title`, '4. Siparişi seçin'),
      text: t(`${G}.s4.text`, 'Listeden bir siparişe tıklayın; sağdaki düğmeler o sipariş için çalışır. Satırdaki menüde Detay Görüntüle, Düzenle, Mutfağa Yazdır, Fiş Yazdır ve İptal Et bulunur.'),
      tips: [
        t(`${G}.s4.tip1`, 'Liste başlığındaki durum filtresiyle yalnız Yeni, Yolda, Teslim Edildi gibi siparişleri görebilirsiniz.'),
        t(`${G}.s4.tip2`, 'Bir müşteri seçiliyken liste yalnız onun siparişlerini gösterir; "Tümüne Dön" ile bütün siparişlere dönün.'),
      ],
    },
    {
      region: 'summary',
      title: t(`${G}.s5.title`, '5. Durumu ilerletin, kurye atayın'),
      text: t(`${G}.s5.text`, 'En alttaki renkli durum düğmesi siparişi bir sonraki adıma taşır. Telefon siparişinde sıra: HAZIR YAP → KURYE ATA → TESLİM ET. "KURYE ATA" kurye seçme penceresini açar.'),
      tips: [
        t(`${G}.s5.tip1`, 'Platform siparişlerinde düğme platforma göre değişir: ONAYLA, HAZIRLA, KURYEYE VER / KURYE ATA / YOLA ÇIK, TESLİM ET. Parantezde saniye yazıyorsa süre bitince düğme açılır.'),
        t(`${G}.s5.tip2`, 'REDDET / İPTAL ET: platform siparişini reddeder ya da iptal eder.'),
        t(`${G}.s5.tip3`, '"RESTORANI KAPAT": platform sekmesinde mağaza açıkken görünür; o platformdaki mağazayı kapatma penceresini açar.'),
      ],
    },
    {
      region: 'summary',
      title: t(`${G}.s6.title`, '6. Ödemeyi alın ve kontrol edin'),
      text: t(`${G}.s6.text`, '"ÖDEME AL" ile NAKİT, POS seçeneklerinden birini (platform siparişinde ONLİNE ÖDEME de) seçin. Nakit tutar ekranın ödeme ayarlarında seçili kasaya, POS tutarı o POS\'a bağlı banka hesabına işlenir; satış faturası oluşur ve eşleşen ürünlerin stoğu düşer.'),
      tips: [
        t(`${G}.s6.tip1`, 'Telefon siparişinde teslimden önce de ödeme alınabilir. İptal edilmiş siparişe ödeme alınamaz.'),
        t(`${G}.s6.tip2`, 'QR Menü, Kiosk ve E-Ticaret siparişleri peşin ödenir; düğmede "PEŞİN ÖDENDİ" yazar.'),
        t(`${G}.s6.tip3`, '"KONTROL YAP": günün siparişlerinde fatura, fiş ve ödeme kaydı eksik mi diye bakar.'),
      ],
    },
    {
      region: 'header',
      title: t(`${G}.s7.title`, '7. Üst çubuk ve alt sayılar'),
      text: t(`${G}.s7.text`, 'Telefon ve kule simgeleri yeşil/mavi ise arayan numara ve anlık bildirim bağlıdır; kırmızı ise bağlantı yoktur. Yenile siparişleri yeniden yükler; ⚙ Ayarlar zil sesi ve yazdırma ayarlarını açar. Alttaki çubuk günün sipariş sayılarını kanal kanal ve TOPLAM olarak gösterir. (i) bu rehberi açar.'),
    },
  ],
});
